import { useMediaQuery, useTheme } from "@mui/material";

export default function useScreen(){
    const theme=useTheme();
    const isMobileScreen=useMediaQuery(theme.breakpoints.down('sm'));
    return {isMobileScreen};
}